export default "__VITE_ASSET__wGrqD4si__"